import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Control, Form, Errors} from 'react-redux-form';
import RegistrationAction from "../../actions/RegistrationAction";
import preloader from '../../image/preloader.gif';

class CheckCode extends Component {

  submit(data) {
    this.props.checkCode(data.code, data.token);
  }

  render() {
    const {requestStatus} = this.props;
    return (
      <div className="row signup-box">
        <div className="col-md-8 col-md-offset-2">
          <Form className="sing-box" model="forms.signVerifyForm" onSubmit={(data) => this.submit(data)}>
            <h1 className="text-center">Please enter verification code</h1>
            <div className="mt10 center">
              <label htmlFor="code">Verification code</label>
              <Control.text model="forms.signVerifyForm.code"
                            className="inline form-control" id="code" type="text" name="code"
                            validators={{
                              required: (val) => val && val.length
                            }}
              />
            </div>
            <div className="center">
              <div className="error-box">
                <Errors
                  className="error"
                  model="forms.signVerifyForm.code"
                  show={(field) => field.submitFailed && !field.valid}
                  messages={{
                    required: 'Please enter verify code'
                  }}
                />
              </div>
              <button disabled={requestStatus} type="submit" className="btn btn-action mt10">Send</button>
              <a href="/#/sign/verify" className="btn btn-default mt10 ml10">Try Again</a>
              <img src={preloader} className={requestStatus ? 'loader-button' : 'loader-button none'} alt="loading..." />
            </div>
          </Form>
        </div>
      </div>
    )
  }
}

export default connect(
  state => ({
    currentStep: state.currentStep,
    requestStatus: state.requestStatus,
  }),
  dispatch => ({
    checkCode: (code, token) => {
      dispatch(RegistrationAction.checkCode(code, token));
    }
  })
)(CheckCode);


/** WEBPACK FOOTER **
 ** ./src/components/Sign/check_code.js
 **/